import { Button } from '../../shared/ui/Button/Button';
import { Stack } from '../../shared/ui/Stack/Stack';
import { Text } from '../../shared/ui/Text/Text';
import styles from './ChangeQuantity.module.scss';

const ChangeQuantity = ({quantity, setQuantity}) =>{
    const addQuantity =() => {
        const newQuantity = quantity + 1;
        setQuantity(newQuantity)
    }
    const removeQuantity = () => {
        if (quantity <= 1) return;
        const newQuantity = quantity - 1;
        setQuantity(newQuantity)
    }
    return (
        <Stack>
            <Button className={styles.btn} onClick={removeQuantity}>-</Button>
            <Text className={styles.text}>{quantity}</Text>
            <Button className={styles.btn} onClick={addQuantity}>+</Button>
        </Stack>
    )
}

export default ChangeQuantity;